import React from 'react';

function GenerateButtons({ onGenerateQuestion, generatingQuestion, isAdmin, onBatchGenerate, batchGenerating, batchProgress, generationPaused }) {
  // Site-wide kill switch (backend QUESTION_GENERATION_PAUSED, surfaced through
  // GET /api/me). Say so instead of offering buttons that answer 503 — a button
  // promising "~90s" that fails instantly reads as a broken site, not a pause.
  if (generationPaused) {
    return (
      <div className="study-generate-area">
        <p className="study-empty-text">
          New question generation is paused right now. Everything already in the question bank still works.
        </p>
      </div>
    );
  }

  return (
    <div className="study-generate-area">
      {generatingQuestion ? (
        <div className="question-progress">
          <div className="question-progress-fill" />
          <div className="question-progress-label">Generating question… (~90s)</div>
        </div>
      ) : (
        <button
          className="study-btn-generate"
          onClick={onGenerateQuestion}
          disabled={batchGenerating}
        >
          + Generate New Question (~90s)
        </button>
      )}
      {isAdmin && (
        batchGenerating ? (
          <div className="question-progress">
            <div className="question-progress-fill question-progress-fill--batch" />
            <div className="question-progress-label">Generating questions… ({batchProgress}/5)</div>
          </div>
        ) : (
          <button
            className="study-btn-generate"
            onClick={onBatchGenerate}
            disabled={generatingQuestion}
          >
            + Generate x5 (~450s)
          </button>
        )
      )}
    </div>
  );
}

export default GenerateButtons;
